import axios from "axios";

export default {
  getAll() {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get("api/tallas", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  getAllByTipoProducto(tipoProductoId) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .get(`api/tallas/${tipoProductoId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  async get(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    try {
      const result = await axios.get(`api/talla/${id}`, headerAuth);
      return result.data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  add(talla) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .post("api/talla", talla, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(talla) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .put(`api/talla/${talla.tallaId}`, talla, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  delete(id) {
    let tokenAuth = localStorage.getItem("access_token");
    let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

    return axios
      .delete(`api/talla/${id}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
